var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 2a1 1 0 011 1v18l-.005.102a1 1 0 01-.893.893L19 22H5l-.103-.005a1 1 0 01-.892-.893L4 21V9.414a1 1 0 01.293-.707l6.414-6.414a1 1 0 01.608-.288l.1-.005H19zm-7 7a1 1 0 01-1 1H5.5v10.5h13v-17H12V9zm-5.349-.5H10.5V4.651L6.651 8.5z",
    fill: "currentColor"
  })));
}
SvgFile.displayName = 'File';
export default SvgFile;